/*
 * @Description: 实用工具类
 * @Author: laoliu,wanqian
 * @Date: 2021-02-07 12:28:58
 */

import Constant from '@/global/Constant.js'
import axios from 'axios';
import { jsonp } from "vue-jsonp"

let Util = {
    /**
     * @Description: 后端返回数组[{}]，把 全部（id:-1)放在第一项，
     * @param data 为必传参数[{}]
     * @Author: sunhuihong
     * @Date: 2022-05-30
     */
    changeArrPosition(data) {
        let obj = {};
        for (let i = 0; i < data.length; i++) {
            if (data[i].id == -1) {
                obj = data[i];
                data.splice(i, 1);
                data.unshift(obj)
            }
        }
        return data;
    },

    /**
     * @Description: 传入的字符串限制只有汉字、数字、中文英文的括号
     * @Author: wanqian
     * @Date: 2022-06-29
     * @param str 传入待处理字符串
     * @param containBrackets 字符串是否能包含中文英文的括号
     */
    filterChineseAndDigitalsAndBrackets(str, containBrackets) {
        if (containBrackets) {
            str = str.replace(/[^a-zA-Z0-9()（）\u4E00-\u9FA5]/g, '');
        } else {
            str = str.replace(/[^a-zA-Z0-9\u4E00-\u9FA5]/g, '');
        }
        return str;
    },

    /**
     * @Description: 将传入名称是重庆的标识ZQ改为CQ（解决机构名字包含重庆生成标识有多音字问题）
     * @Author: wanqian
     * @Date: 2022-06-29
     * @param name 传入名称
     * @param identify 传入标识
     */
    changeIdentifyOfZQToCQ(name, identify) {
        if (name.indexOf('重庆') != -1) {
            identify = identify.replace(/ZQ/g, 'CQ');
        }
        return identify;
    },

    /**
     * @Description: 获取两个日期相差天数
     * @Author: shh
     * @Date: 2022-07-22 11:36:23
     * @param {*} firstDate 传入日期字符串1
     * @param {*} secondDate 传入日期字符串2
     */
    getDifferDay(firstDate, secondDate) {
        let startDate = new Date(firstDate);
        let endDate = new Date(secondDate);
        let msecNum = endDate.getTime() - startDate.getTime();
        return msecNum / parseFloat(24 * 60 * 60 * 1000);
    },

    /**
     * @Description: 最大余额法解决图表百分比总和不是100% 的问题
     * @Author: shh
     * @Date: 2022-07-26 11:36:23
     * @param {*} valueList 传入要计算数据的数组
     * @param {*} index 传入要计算数组中值的下表
     * @param {*} precision 传入百分比保留几位小数，默认保留2位小数
     */
    getPercentValue(valueList, index, precision) {
        // 判断是否为空
        if (!valueList[index]) { return 0; }
        // 求和
        let sum = valueList.reduce(function(item, val) {
            return item + (isNaN(val) ? 0 : val);
        }, 0)
        if (sum === 0) { return 0; }
        // 10的2次幂是100，用于计算精度。
        let digits = Math.pow(10, precision);
        // 扩大比例100，
        let votesPerQuota = valueList.map(function(val) {
                return (isNaN(val) ? 0 : val) / sum * digits * 100;
            })
            // 总数，扩大比例意味的总数要扩大
        let targetSeats = digits * 100;
        // 再向下取值，组成数组
        let seats = votesPerQuota.map(function(votes) {
                return Math.floor(votes);
            })
            // 再新计算合计，用于判断与总数量是否相同，相同则占比会100%
        let currentSum = seats.reduce(function(item, val) {
                return item + val;
            }, 0)
            // 余数部分的数组：原先数组减去向下取值的数组，得到余数部分的数组
        let remainder = votesPerQuota.map(function(votes, indexs) {
                return votes - seats[indexs];
            })
            // 给最大最大的余额加1，凑个占比100%；
        while (currentSum < targetSeats) {
            //  找到下一个最大的余额，给其加1
            let max = Number.NEGATIVE_INFINITY;
            let maxId = null;
            for (let i = 0, len = remainder.length; i < len; ++i) {
                if (remainder[i] > max) {
                    max = remainder[i];
                    maxId = i;
                }
            }
            // 对最大项余额加1
            ++seats[maxId];
            // 已经增加最大余数加1，则下次判断就可以不需要再判断这个余额数。
            remainder[maxId] = 0;
            // 总的也要加1，为了判断是否总数是否相同，跳出循环。
            ++currentSum;
        }
        // 这时候的seats就会总数占比会100%
        return seats[index] / digits
    },

    /**
     * @Description: 得到当前时间所在的本周的开始日期和结束日期
     * @Author: shh
     * @Date: 2022-07-26 11:36:23
     */
    getWeekStartDate() {
        let time = new Date().getTime(); //获得当前时间的毫秒值
        let dayCode = new Date(time).getDay(); //获取星期 返回值：number(0-6) //0=周日
        let dayLong = 24 * 60 * 60 * 1000;
        return this.dateFormat(new Date((dayCode == 0) ? (time - dayLong * 7) : (time - dayLong * (dayCode - 1))));
    },

    /**
     * @Description: 得到当前时间所在的本月的开始日期和结束日期
     * @Author: shh
     * @Date: 2022-07-26 11:36:23
     */
    getMonthStartDate() {
        let time = new Date().getTime(); //获得当前时间的毫秒值
        let currentDay = new Date(time);
        return this.dateFormat(new Date(currentDay.setDate(1)));
    },

    /**
     * @Description: 将时间戳转化为年月日YYYY-DD-MM
     * @Author: shh
     * @Date: 2022-07-26 11:36:23
     * @param {*} date 时间戳
     */
    dateFormat(time) {
        let year = time.getFullYear();
        let month = time.getMonth() + 1;
        let day = time.getDate();
        return year + '-' + (month < 10 ? '0' + month : '' + month) + '-' + (day < 10 ? '0' + day : '' + day);
    },

    /**
     * @Description: 限制input只能输入整数或保留一位小数的数值
     * @Author: gaohc
     * @Date: 2022-09-07 14:36:23
     * @param {*} value input输入的值
     */
    limitInputNumberOrDecimal(value) {
        return ("" + value) // 第一步：转成字符串
            .replace(/[^\d^\.]+/g, "") // 第二步：把不是数字，不是小数点的过滤掉
            .replace(/^0+(\d)/, "$1") // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
            .replace(/^\./, "0.") // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
            // 第五步：最终匹配得到结果 以数字开头，只有一个小数点,而且小数点后面只能有0到1位小数
            .match(/^\d*(\.\d?)/g)[0] || "";
    },

    /**
     * @Description: 删除数组中某个符合条件的对象
     * @Author: gaohc
     * @Date: 2022-09-09
     * @param list   目标数组
     * @param pro  	 待删除数组对象的目标属性
     * @param value  待删除数组对象的目标属性的值
     */
    delMemoHandler(list, pro, value) {
        return list.filter((item) => {
            return item[pro] != value
        });
    },

    /**
     * @Description: 根据数组对象中的某个属性值判断是否包含某个对象,
     * 有则替换,无则新增
     * @Author: gaohc
     * @Date: 2022-09-09
     * @param initialArr   目标数组
     * @param obj  	       待替换的对象
     * @param pro          数组对象中的某个属性
     */
    formateArrObjData(initialArr, obj, pro) {
        if (!(initialArr instanceof Array) || !(obj instanceof Object) || !pro) {
            return []
        }
        let index = initialArr.findIndex((val) => val[pro] === obj[pro]);
        // 如果有就替换没有就新增
        if (initialArr.findIndex((val) => val[pro] === obj[pro]) !== -1) {
            initialArr.splice(index, 1, obj);
        } else {
            initialArr.push(obj);
        }
        return initialArr
    },

    /**
     * @Description: 获取目标数组的某个属性的值形成逗号分隔的字符串
     * @param {*} arr 参数1：必传，目标数组
     * @param {*} key 参数2：必传，目标数组的属性
     * @Author: gaohc
     * @Date: 2022-08-12
     */
    getStrFromArray(arr, key) {
        if (!arr.length) return ''
        if (arr.length > 1) {
            return arr.map(item => item[key]).join(",");
        } else {
            return arr[0][key];
        }
    },

    /**
     * @Description: 根据属性名和属性值找到在目标数组中包含目标属性名等于属性值的对象
     * @param {*} key 参数1：必传，目标属性名
     * @param {*} value 参数2：必传，目标属性值
     * @param {*} arr 参数3：必传，目标数组
     * @Author: gaohc
     * @Date: 2022-08-12
     */
    searchKeyWithValueInArr(key, value, arr) {
        let keyResult = {};
        arr.forEach(function(item) {
            if (value == item[key]) {
                keyResult = item;
            }
        });
        return keyResult;
    },

    /**
     * @Description: 去除为null的参数并得到拼接后的参数字符串
     * @param {obj} obj 参数对象集合
     * @Author: gaohc
     * @Date: 2022-10-19
     */
    joinUrlParams(obj) {
        let result = '';
        let item;
        for (item in obj) {
            if (obj[item] && String(obj[item])) {
                result += `&${item}=${obj[item]}`;
            }
        }
        if (result) {
            result = '?' + result.slice(1);
        }
        return result;
    },

    /**
     * @Description: 验证邮箱
     * @Author: sunhuihong
     * @Date: 2022-10-21
     * @param {string} email 待验证邮箱
     * @return {boolean} true/false
     */
    validateEmail(email) {
        let reg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        return reg.test(email);
    },

    /**
     * @Description: 验证证件注册号(须为18位数字|大写字母)
     * @Author: sunhuihong
     * @Date: 2022-10-21
     * @param {string} email 待验证证件注册号
     * @return {boolean} true/false
     */
    validateBizLicenseNo(bizLicenseNo) {
        let reg = /[A-Z0-9]{18}/g;
        return reg.test(bizLicenseNo);
    },

    /**
     * @Description: 限制input只能输入两位小数
     * @Author: shh
     * @Date: 2022-11-14 14:36:23
     * @param {*} value input输入的值
     */
    limitInputTwoDecimal(value) {
        return (value.match(/^\d*(\.?\d{0,2})/g)[0]);
    },

    /**
     * @Description: 比对数组是否相同
     * @Author: gaohc
     * @Date: 2024-05-15 
     * @param {arr1} arg1 待比对数组 
     * @param {arr2} arg2 比对数组
     * @return {Boolean} 运算结果 true 相同 false 不同
     */
    compareSameArr(arr1, arr2) {
        if (arr1.length !== arr2.length) {
            return false;
        }
        return !arr1.some(item => !arr2.includes(item))
    },

    /**
     * @Description: 报表导出
     * @Author: fengal
     * @Date: 2023-09-08 15:26:23
     * @param 请求地址url
     * @param 请求参数params
     */
    exportExcel(url, params) {
        return new Promise((resolve) => {
            axios.get(url, { params: params, 'responseType': 'blob' }).then((res) => {
                const blob = new Blob([res.data]);
                const contentDisposition = res.headers['content-disposition'];
                const filenameMatch = contentDisposition && contentDisposition.match(/filename="(.+)"/);

                let filename = ""
                if (filenameMatch) {
                    const encodedFilename = filenameMatch[1];
                    filename = decodeURIComponent(encodedFilename);
                }

                let link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = filename;
                link.click();
                URL.revokeObjectURL(link.href);

                resolve()
            });
        })
    },

    /**
     * @Description: 腾讯地图地址解析（地址转坐标）
     * @Author: wanq
     * @Date: 2024-07-29 13:46:23
     * @param {address} 地址
     */
    qqMapGeocoder(address) {
        return new Promise((resolve, reject) => {
            jsonp('https://apis.map.qq.com/ws/geocoder/v1', {
                address: address,
                key: Constant.QQMAPWX_KEY,
                output: "jsonp"
            }).then(data => {
                resolve(data);
            }).catch(err => {
                reject(err);
            })
        })
    },

    /**
	 * @Description: 把金额转化为每隔3位用逗号分隔，比如20481.34转换为20,281.34
	 * @Author: sunhuihong
	 * @Date: 2024-12-23
	 */
	formattedAmount(amount) {
	    return Number(amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
	},

    /**
     * @Description: 根据服务机构Id查询对应机构下的医院列表
     * @Author: shh
     * @Date: 2025-08-14 15:46:23
     * @param {negoRefondReviewId} 退款审核id
     * @param {instId} 机构id
     * @param {vue} 实例对象vue
     */
    queryHspListFromInstId(instId, vue){
        return new Promise((resolve) => {
            let params = {institutionId: instId};
            let header = vue.encryptionUtil.signatureParams(params,
              Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
            let requestData = {
              method: 'GET',
              url: Constant.URL_GET_HOSPITAL_COMMENUSERFILTERDO4_INSTITUTION,
              param: params,
              header: header,
              contentType: vue.commonConst.CNTYPE_URLENCODED,
            };
    
            vue.vueRequest(requestData).then((result) => {
              if (result ==  null) {
                return;
              }
              resolve(result.data)
            });
        });
    },
}

export default Util


// WEBPACK FOOTER //
// ./src/global/Util.js